import "bootstrap/js/dist/modal";

$(function(){
    var modalDiv = $('#school-list-modal');
    var updateTimer;

    var fetchPage = function(page, query){
        modalDiv.find('.modal-body').empty();
        modalDiv.modal();

        var url = '/schools/?ret=' + window.location.href;
        if(page){
            url += '&page=' + page;
        }
        if(query){
            url += '&query=' + query;
        }
        $.get(url, function(data){
            modalDiv.find('.modal-body').html(data);

            var schoolSearch = $('#school-search');
            var searchText = schoolSearch.val();
            if(searchText){
                schoolSearch.focus();
                schoolSearch[0].setSelectionRange(searchText.length, searchText.length);
            }
        });
    }

    $(document).on('click', '.school-filter', function(e){
        e.preventDefault();

        fetchPage($(this).data('page'));
    });

    $(document).on('input', '#school-search', function(e){
        var self = this;
        if(updateTimer){
            clearTimeout(updateTimer);
        };

        updateTimer = setTimeout(function(){
            fetchPage(1, $(self).val());
        }, 1000);
    });

    $(document).on('click', '.school-entry', function(e){
        e.preventDefault();

        var level_list = $(this).siblings('.school-level-list');
        modalDiv.find('.modal-body').html(level_list);
        level_list.removeClass('d-none');
    });
});
